module.exports = __webpack_public_path__ + "img/es.b336c61e.svg";